import { HiLogin } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function EnterDigikala({ redirectUrl }) {
  return (
    <div className="d-flex flex-column align-items-center py-2 py-lg-5">
      <p>
        برای دریافت اطلاعات از سمت دیجی‌کالا، نیاز به ورود و تایید دسترسی های
        مورد نیاز است.
      </p>

      <Link
        to={redirectUrl}
        className="buttonUi text-center btn-success-style mt-2"
      >
        <span>ورود به دیجی‌کالا</span>
        <span className="me-2">
          <HiLogin />
        </span>
      </Link>
    </div>
  );
}
